import BaseModal from 'components/Modals/BaseModal'
import useAuth from 'hooks/useAuth'
import { useState } from 'react'
import { hashGenerator } from 'utils/hashGenerator'
import { CheckCircleIcon } from '@heroicons/react/solid'

interface TransactionReceiptProps {
  isVisible: boolean
  onClose: () => void
  tx?: { date: string; amount: string }
}

const TransactionReceipt = ({ isVisible, onClose, tx }: TransactionReceiptProps) => {
  const auth = useAuth()
  const [isSender] = useState(localStorage.getItem('token') === 'sender')

  return (
    <BaseModal isVisible={isVisible} onClose={onClose} size="md">
      <div className="bg-gradient-to-br from-primary-500 to-primary-600 p-6 text-white">
        <div className="flex items-center gap-3 mb-4">
          <CheckCircleIcon className="w-8 h-8" />
          <h3 className="text-xl font-bold">Transaction Complete</h3>
        </div>
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span className="text-primary-200 block mb-1">Reference</span>
            <span className="font-mono font-medium">{hashGenerator(tx?.date ?? '')}</span>
          </div>
          <div>
            <span className="text-primary-200 block mb-1">Date</span>
            <span className="font-medium">
              {isSender
                ? tx?.date
                : new Date(tx?.date ?? '').toLocaleString('en-US', auth.formatOptions)}
            </span>
          </div>
        </div>
      </div>

      <div className="p-6 space-y-4">
        <div className="flex justify-between py-3 border-b border-neutral-100">
          <span className="text-neutral-500">Description</span>
          <div className="text-right">
            <span className="block font-semibold text-neutral-800">Fund Transfer</span>
            <span className="text-sm text-neutral-500">UnionBank</span>
          </div>
        </div>

        <div className="flex justify-between py-3 border-b border-neutral-100">
          <span className="text-neutral-500">From</span>
          <div className="text-right">
            <span className="block font-semibold text-neutral-800">UBX Entity</span>
            <span className="text-sm text-neutral-500">**** 2222</span>
          </div>
        </div>

        <div className="flex justify-between py-3 border-b border-neutral-100">
          <span className="text-neutral-500">To</span>
          <div className="text-right">
            <span className="block font-semibold text-neutral-800">Juan dela Cruz</span>
            <span className="text-sm text-neutral-500">**** 1111</span>
          </div>
        </div>

        <div className="flex justify-between py-3">
          <span className="text-neutral-500">Amount</span>
          <span className="text-xl font-bold text-neutral-800">{tx?.amount ?? ''}</span>
        </div>

        <button
          onClick={onClose}
          className="btn-primary btn-md w-full mt-4"
        >
          Done
        </button>
      </div>
    </BaseModal>
  )
}

export default TransactionReceipt
